import { IPDefaultButton, IPPrimaryButton, IPSeparator, IPTooltipHost } from 'baseComponents';
import { IPStack } from 'baseComponents/Stack/IPStack';
import { globalStackTokensGapSmall } from 'globalStyles';

interface IDialogFooterProps {
  onSubmit: () => void;
  onCancel?: () => void;
  onTertiary?: () => void;
  buttonPosition: 'end' | 'start';
  secondaryText?: string;
  primaryText: string;
  tertiaryText?: string;
  tertiaryTooltip?: string;
  disablePrimary?: () => boolean;
  disableTertiary?: () => boolean;
}

const ButtonDialogFooter = (props: IDialogFooterProps) => {
  return (
    <IPStack tokens={globalStackTokensGapSmall}>
      <IPSeparator />
      <IPStack.Item>
        <IPStack horizontal wrap horizontalAlign={props.buttonPosition} tokens={globalStackTokensGapSmall}>
          <IPStack.Item>
            <IPPrimaryButton
              text={props.primaryText}
              onClick={props.onSubmit}
              disabled={props.disablePrimary ? props.disablePrimary() : undefined}
            />
          </IPStack.Item>
          {props.onCancel && (
            <IPStack.Item>
              <IPDefaultButton text={props.secondaryText} onClick={props.onCancel} />
            </IPStack.Item>
          )}
          {props.tertiaryText && (
            <IPStack.Item>
              <IPTooltipHost content={props.tertiaryTooltip}>
                <IPDefaultButton
                  text={props.tertiaryText}
                  onClick={props.onTertiary}
                  disabled={props.disableTertiary ? props.disableTertiary() : undefined}
                />
              </IPTooltipHost>
            </IPStack.Item>
          )}
        </IPStack>
      </IPStack.Item>
    </IPStack>
  );
};

export default ButtonDialogFooter;
